const styles = {
  container: {
    padding: {
      xs: '0',
      xl: '40px 62px',
    },
    borderRadius: '16px',
    border: {
      xl: '1.5px solid #29EDFF',
    },
    borderColor: {
      xl: 'kit.stroke.turquoise',
    },
  },
  title: {
    color: 'kit.text.accent',
    marginBottom: {
      xs: '32px',
      xl: '40px',
    },
  },
  note: {
    color: 'kit.text.mainInverse',
    fontSize: {
      xl: '15px',
    },
    marginBottom: {
      xs: '24px',
      xl: '0',
    },
  },
  videoWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: {
      xl: '32px',
    },
  },
};

export default styles;
